import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import BlueLogo from "./BlueLogo";

const EmployerBackgroundPics = ({
  user,
  profile,
  setemployerbio,
  setColor,
  color,
  setEditing,
}) => {
  return (
    <Fragment>
      <div className="profile-background-pics">
        <div className="background-image-container">
          {profile &&
          profile.backgroundimageone === "Innovate_Me_logo_blue.png" ? (
            <div className="profile-logo-container">
              <BlueLogo />
            </div>
          ) : (
            <img
              className={"profile-background-image"}
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/innovators/${profile.backgroundimageone}`}
              alt="background"
            />
          )}
          <div className="profile-user-info">
            {user && user.user === profile.user ? (
              <div
                className="profile-user-info-button-blue blue"
                onMouseOver={() => setColor(true)}
                onMouseLeave={() => setColor(false)}
              >
                <Link to={`/${user.channelid}/edit`}>
                  <span
                    className={color ? "black" : "blue"}
                    onClick={() => setEditing(true)}
                  >
                    Edit Profile
                  </span>
                </Link>
              </div>
            ) : (
              <div
                className="profile-user-info-button-blue blue"
                onClick={() => setemployerbio(true)}
              >
                Biography
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EmployerBackgroundPics;
